import React, { useState } from "react";
import { FaCircleXmark } from "react-icons/fa6";
import { useGetAllSuperVisorRoutesStopQuery } from "../../Data/services/supervisorApi";
import { Description, SubTitle } from "../CustomComponents";
import ModalContainer from "../ModalContainer";
import cssStyles from "./styles/editModal.module.scss";
import GrowSpinner from "../CustomComponents/GrowSpinner";

const ViewStopsModal = ({ handleClose, editData }) => {
  const [searchQuery, setSearchQuery] = useState("");

  const { data, isSuccess, isLoading, isFetching, refetch } =
    useGetAllSuperVisorRoutesStopQuery(
      {
        search: searchQuery || "",
        route_id: editData?.id,
      },
      { refetchOnMountOrArgChange: true }
    );

  return (
    <div>
      <ModalContainer handleClose={handleClose}>
        <div className={cssStyles.modalContainer}>
          <div className="d-flex align-items-start w-100 justify-content-between mb-4">
            <div className="d-flex gap-2 flex-column">
              <p className="fs-4 fw-medium m-0">{data?.route_name} Stops</p>
              <div>{data?.order_number}</div>
            </div>
            <FaCircleXmark
              onClick={handleClose}
              style={{ cursor: "pointer" }}
            />
          </div>
          <div className="w-100">
            {isLoading ? (
              <GrowSpinner className={"flex-center"} />
            ) : data?.data?.length > 0 ? (
              <>
                {data?.data?.map((dt) => (
                  <>
                    <div className="flex-between align-items-start">
                      <SubTitle text="Location:" classes="fs-6" />
                      <Description
                        text={dt?.customer_location || "-"}
                        classes={`fs-7 fw-normal ${cssStyles.Detail}`}
                      />
                    </div>
                    <div className="flex-between">
                      <SubTitle text="Customer Name:" classes="fs-6" />
                      <Description
                        text={dt?.customer_name || "-"}
                        classes={`fs-7 fw-normal ${cssStyles.Detail}`}
                      />
                    </div>
                    <div className="flex-between">
                      <SubTitle text="Contact:" classes="fs-6" />
                      <Description
                        text={dt?.phone_number || "-"}
                        classes={`fs-7 fw-normal ${cssStyles.Detail}`}
                      />
                    </div>
                    <div className="line-separate mt-2 mb-2"></div>
                  </>
                ))}
              </>
            ) : (
              <p className="d-flex align-item-center justify-content-center">
                No Data Found
              </p>
            )}
          </div>
        </div>
      </ModalContainer>
    </div>
  );
};

export default ViewStopsModal;
